/** Full-page preview route for a brief (App.tsx). */
export function briefPreviewPath(brandId: string, campaignId: string, briefId: string, context?: string): string {
  const base = `/brand/${encodeURIComponent(brandId)}/campaigns/${encodeURIComponent(campaignId)}/briefs/${encodeURIComponent(briefId)}/preview`;
  return context ? `${base}?context=${encodeURIComponent(context)}` : base;
}
